import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import t from '../../lib/I18n';
import classnames from 'classnames';
import config from '../../config';
import Icon from '../general/Icon';
import OrderFare from '../../records/order/Fare';
import { getTicketTypeRefundDescription } from '../../helpers/RefundCopy';

const TicketDescription = ({ fare }) => {
    const ticketDescription = getTicketTypeRefundDescription(fare);
    return ticketDescription && <li>{ ticketDescription }</li>;
};

TicketDescription.propTypes = {
    fare: PropTypes.instanceOf(OrderFare).isRequired,
};

const TicketRestrictions = ({ fare }) => {
    return fare.getDescription() ? <li>{ _.truncate(fare.getDescription(), { length: 100 }) }</li> : null;
};

TicketRestrictions.propTypes = {
    fare: PropTypes.instanceOf(OrderFare).isRequired,
};


const FareRestrictions = ({ fare, useBootstrap = false }) => {
    let restrictions = [
        <div key={ 0 } className="fare-restrictions__item">
            <TicketDescription fare={fare} />
            <TicketRestrictions fare={fare}/>
        </div>
    ];

    if (fare.isGroupSave()) {
        restrictions.push(
            <div key={ restrictions.length } className="fare-restrictions__item">
                {t('order.summary.groupSave.text')}&nbsp;
            <a className={ classnames({ 'text-sm': useBootstrap }) } target="_blank" href={ config.get('groupSaveDetailsUrl') }>
                    {t('order.summary.groupSave.link')} <Icon icon="externallink" className="otrl-inline" />
                </a>
            </div>
        );
    }

    if (fare.isCarnet()) {
        restrictions.push(
            <div key={ restrictions.length } className="fare-restrictions__item">
                {fare.getCarnetInformation().text}
            </div>
        );
    }

    // TODO: Order refunding and changing your ticket...
    return useBootstrap ? restrictions : (
        <div className="fare-restrictions">
            { restrictions }
    </div>);
};

FareRestrictions.propTypes = {
    fare: PropTypes.instanceOf(OrderFare).isRequired,
    useBootstrap: PropTypes.bool
};

FareRestrictions.defaultProps = {
    useBootstrap: false
};

export default FareRestrictions;
